// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class Hint {
  public id!: string;

  public value!: string;

  public static fromDto(dto: any): Hint {
    const hint: Hint = new Hint();
    hint.id = dto.id;
    hint.value = dto.value;
    return hint;
  }
}
